import * as preact from "preact";

import "./style.css";

const { h } = preact;

function Loading() {
    return (
        <div class="organizationSummaryLoading">
            <div class="logo breathe"></div>
            <div>
                <div class="title breathe"></div>
                <div class="counts breathe"></div>
            </div>
        </div>
    );
}

export default Loading;
